import {Component, OnInit, ChangeDetectorRef} from '@angular/core';
import { AppService } from '../shared/services/app.service';

declare var Quagga:any;

@Component({
  selector: 'app-scanner',
  templateUrl: './scanner.component.html',
  styleUrls: ['./scanner.component.css']
})
export class ScannerComponent implements OnInit {

  result:string;

  constructor(
    private _ref: ChangeDetectorRef,
    private _appService: AppService
  ) { }

  ngOnInit() {
    this._appService.hideLoader();
  }

  start() {
    let that = this;
    that.result = null;
    Quagga.init({
      inputStream : {
        name : "Live",
        type : "LiveStream",
        target: document.querySelector('#scanner-target')
      },
      decoder : {
        readers : ["code_128_reader"]
      },
      locate: true
    }, function(err) {
      if (err) {

        return
      }
      console.log("Initialization finished. Ready to start");
      Quagga.start();


      Quagga.onDetected(function (result) {
        if(result) {
          that.result = result.codeResult.code;
          that._ref.detectChanges();
        }
      });
    });
  }

  stop() {
    Quagga.stop();
  }

}



// WEBPACK FOOTER //
// ./src/app/scanner/scanner.component.ts